import PropTypes from "prop-types";
import { Clear, Search } from "@mui/icons-material";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import { useState } from "react";

export const SearchTextField = ({ onChange, defaultValue = "", ...props }) => {
  const [value, setValue] = useState(defaultValue);

  const handleChange = (event) => {
    setValue(event.target.value);
    onChange(event);
  };

  const handleClear = () => {
    setValue("");
    onChange({ target: { value: "" } });
  };

  return (
    <TextField
      {...props}
      value={value}
      onChange={handleChange}
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <Search />
            </InputAdornment>
          ),
          endAdornment: value && (
            <InputAdornment position="end">
              <IconButton onClick={handleClear}>
                <Clear />
              </IconButton>
            </InputAdornment>
          ),
        },
      }}
    />
  );
};

SearchTextField.propTypes = {
  onChange: PropTypes.func.isRequired,
  defaultValue: PropTypes.string,
};
